import { Component, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { HCPService } from '../hcp.service';

interface DiffRow {
  label: string;
  oldValue: string;
  newValue: string;
  changed: boolean;
}

@Component({
  selector: 'crm-hcp-edit-request-diff',
  templateUrl: './edit-request-diff.component.html',
  styleUrls: ['./edit-request-diff.component.css']
})
export class HcpEditRequestDiffComponent {
  @ViewChild('diffModal') diffModal: ModalDirective;
  rows: DiffRow[] = [];
  hasOriginal = true;

  private fieldDefs = [
    { field: 'fullName', label: 'Name' },
    { field: 'englishName', label: 'English Name' },
    { field: 'phone', label: 'Phone' },
    { field: 'email', label: 'Email' },
    { field: 'specialityName', label: 'Speciality' },
    { field: 'active', label: 'Active' },
    { field: 'goldenList', label: 'Golden List' }
  ];

  constructor(private readonly hcpService: HCPService) { }

  show(editRequestId: number) {
    this.hcpService.getHcpEditRequestComparison(editRequestId).subscribe((response: any) => {
      const original = response.original;
      const proposed = response.proposed;
      this.hasOriginal = !!original;
      const allRows = this.fieldDefs.map(def => {
        const oldValue = original ? original[def.field] : null;
        const newValue = proposed ? proposed[def.field] : null;
        return {
          label: def.label,
          oldValue: this.displayValue(oldValue),
          newValue: this.displayValue(newValue),
          changed: this.hasOriginal && this.normalize(oldValue) !== this.normalize(newValue)
        };
      });
      // When we have a real original to compare against, only the fields that actually
      // changed are worth showing. Without one there's nothing to filter by, so fall back
      // to showing every proposed value.
      this.rows = this.hasOriginal ? allRows.filter(r => r.changed) : allRows;
      this.diffModal.show();
    });
  }

  hide() {
    this.diffModal.hide();
  }

  private normalize(value: any): string {
    if (value === null || value === undefined) return '';
    return String(value);
  }

  private displayValue(value: any): string {
    if (value === null || value === undefined || value === '') return '-';
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    return String(value);
  }
}
